import React from 'react';
import { Link } from 'gatsby';
import { Logo } from './logo';

const Navbar = class extends React.Component {
  componentDidMount() {
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(
      document.querySelectorAll('.navbar-burger'),
      0,
    );
    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
      // Add a click event on each of them
      $navbarBurgers.forEach((el) => {
        el.addEventListener('click', () => {
          // Get the target from the "data-target" attribute
          const target = el.dataset.target;
          const $target = document.getElementById(target);

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle('is-active');
          $target.classList.toggle('is-active');
        });
      });
    }
  }

  render() {
    return (
      <nav className="navbar is-transparent" role="navigation" aria-label="main-navigation">
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" title="Logo">
              <Logo width="28" height="28" style={{ marginRight: '8px' }} />
              <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>Цвет Папоротника</h1>
            </Link>
            {/* Hamburger menu */}
            <div className="navbar-burger burger" data-target="navMenu">
              <span />
              <span />
              <span />
            </div>
          </div>
          <div id="navMenu" className="navbar-menu">
            <div className="navbar-start has-text-centered">
              <Link className="navbar-item is-hidden-desktop" to="/">
                Главная
              </Link>
              <Link className="navbar-item" to="/gifts">
                Цветочные подарки
              </Link>
              <Link className="navbar-item" to="/promo">
                Акции
              </Link>
              <Link className="navbar-item" to="/decor">
                Декор
              </Link>
              <Link className="navbar-item" to="/workshops">
                Мастер-классы
              </Link>
              <Link className="navbar-item" to="/portfolio">
                Портфолио
              </Link>
              <Link className="navbar-item" to="/payment-and-delivery">
                Оплата и доставка
              </Link>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
